'use client';

import { useInfoProject } from '@/modules/common/hooks/useInfoProject';
import { getContentByLicense, type IContentByLicense } from '../helpers';

export const useContentByLicense = (contentByLicense?: IContentByLicense[]) => {
  const { data: project } = useInfoProject();

  return getContentByLicense(contentByLicense, project?.license);
};
